import { useMemo } from "react";
import { GenerateTreinamentoCargoColumnDefs } from "./columns";
import { useTreinamentoCargoCadastroViewModel } from "../../viewModels/treinamento_cargo_cadastro_view_model";
import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { CargoTreinamentoCargo } from "../../../domain/models/cargo_treinamento_cargo";

import RefreshButton from "../../../../../common/components/refresh_button";
import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";

/**
 * TreinamentoCargoCadastro
 */

export const TreinamentoCargoCadastro = () => {
  const viewModel = useTreinamentoCargoCadastroViewModel();

  const columnsDef = useMemo(() => {
    return GenerateTreinamentoCargoColumnDefs();
  }, []);

  return (
    <>
      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            RH
          </Link>
          <Typography className="text-primary-green">
            Treinamento X Cargo
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Treinamento X Cargo</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>
        </div>

        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  selectedTreinamento={viewModel.selectedTreinamento}
                  treinamentos={viewModel.treinamentos ?? []}
                  onSelectTreinamento={viewModel.handleTreinamentoSelect} />

                {
                  (viewModel.cargos && viewModel.cargos.length > 0) &&
                  <Stack spacing={0} marginBottom={4}>
                    <div className="flex flex-col justify-between flex-1">
                      <TablePagination
                        component="div"
                        count={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page - 1}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        onPageChange={(_, p) => viewModel.handlePageChange(p)}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                    </div>

                    <StyledDataGrid
                      tableName="treinamento_cargo_cadastro"
                      disableRowSelectionOnClick={true}
                      disableColumnMenu={false}
                      checkboxSelection={true}
                      getRowId={(row: CargoTreinamentoCargo) => row.idCargo}
                      columns={columnsDef}
                      loading={viewModel.loading}
                      rowSelectionModel={viewModel.selectionModel}
                      onRowSelectionModelChange={viewModel.handleCargoRowSelectionChange}
                      rows={viewModel.cargos}
                      rowCount={viewModel.cargos.length}
                      pageSizeOptions={[10, 25, 50, 100]}
                      paginationMode="server"
                      paginationModel={{
                        page: viewModel.pagination.page,
                        pageSize: viewModel.pagination.rowsPerPage,
                      }} />

                    <TablePagination
                      component="div"
                      count={viewModel.pagination.totalItems}
                      page={viewModel.pagination.page - 1}
                      onPageChange={(_, p) => viewModel.handlePageChange(p)}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                      onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                  </Stack>
                }
              </>
            )
        }
      </div>
      {
        (viewModel.cargos && viewModel.cargos.length > 0) &&
        <BottomBar>
          <div className="w-full h-full items-center justify-end flex p-4 gap-4">
            <div className="w-[130px]">
              {viewModel.saving
                ? (
                  <PrimaryButton>
                    Salvando...
                  </PrimaryButton>
                ) : (
                  <PrimaryButton
                    onClick={viewModel.handleSubmit}
                    startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                    Salvar
                  </PrimaryButton>
                )}
            </div>
          </div>
        </BottomBar>
      }
    </>
  );
}